














































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    DatePicker,
    TimePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class FormEditarTimeSyncStreamax extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  accion!: any;
  ordesList2: any;
  data: any = {};
  rules = {
    required: (value: any) => !!value || 'Required.',
    counter: (value: any) => value.length <= 15 || 'Maximo 15 caracteres',
    soloLetras: (value: any) => {
      return value.match(/^[a-zA-Z]*$/) || 'Solo se permiten letras';
    },
    soloNumeros: (value: any) => {
      return value.match(/^[0-9]*$/) || 'Solo se permiten letras';
    },
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      }
    },
  };
  async getTimeSeleccionado() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/getConfCamaraPower'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }
  /*    async getTime() {
           this.ordesList2 = (await this.getTimeSeleccionado()) || [];
           this.data = this.ordesList2[0];
           this.formFields.powerMode.value = parseInt(this.data['?column?'].LittlePowerEnable);
           const on = parseInt(this.data['?column?'].PowerOnTime) / 3600;
           const off = this.convertirSegundosAHora(parseInt(this.data['?column?'].PowerOffTime));
           this.formFields.delayOff.value = parseInt(this.data['?column?'].switch);
           this.formFields.powerOn.value = moment(on, 'HHmm');
           this.formFields.powerOff.value = moment(off, 'HHmm');
           this.formFields.recDelayTime.value = this.data['?column?'].delay;
           this.formFields.autoReboot.value = parseInt(this.data['?column?'].switch);
           this.formFields.rebootTime.value = this.convertirSegundosAHora(parseInt(this.data['?column?'].RebootTime));
           this.formFields.lowVoltagePowOff.value = parseInt(this.data['?column?'].LowPowerOff);
         }
       
         mounted() {
           this.getTime();
         } */
  convertirSegundosAHora(segundos: number): string {
    console.log('prueba:' + segundos);
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    const horaString = horas.toString().padStart(2, '0');
    const minutosString = minutos.toString().padStart(2, '0');
    return `${horaString}${minutosString}`;
  }
  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
    console.log(this.formFields);
  }
  onSelectionChanged(params: any) {}
  formFields: {
    time: any;
    fecha: any;
    satellite: any;
    ntpSync: any;
    centerServerCheck: any;
    centerServer: any;
  } = {
    time: {
      label: 'Time',
      value: moment('00:00', 'HHmm'),
      selectedValue: '17:05:26',
    },
    fecha: {
      label: 'Fecha',
      value: '',
    },
    satellite: {
      label: 'Satellite',
      value: 1,
      check: false,
    },
    ntpSync: {
      label: 'NTP Sync',
      value: 1,
      check: false,
    },
    centerServerCheck: {
      label: 'Center Server',
      value: 1,
      check: true,
    },
    centerServer: {
      label: 'Center Server',
      value: '0',
      items: [
        { label: 'Server 1', id: '0' },
        { label: 'Server 2', id: '1' },
        { label: 'Server 3', id: '2' },
      ],
    },
  };
  selectedDate() {
    return (this.formFields.fecha.value = moment(
      this.formFields.fecha.value
    ).format('DD/MM/YYYY'));
  }
  selectedCenterServer() {
    return this.formFields.centerServer.items.find(
      (item: { id: any }) => item.id === this.formFields.centerServer.value
    );
  }
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
